export const css = {
	root: 'fklGrv-O',
	' _key': 'afcpe-theme/afcpe/landing-page/general'
};

export default css;
